import PropTypes from 'prop-types';
import React from 'react';
import { ClickAwayListener, DialogContent, Modal, Paper } from '@mui/material';

import styles from './Deliveries.module.css';
import modalStyles from '../ReusableComponents/ReusableComponents.module.css';
import DeliveryDetails from './DeliveryDetails';
import BookingTypes from '../../Lib/Constants/booking-types';
import BlockDetails from './BlockDetails';

export default function ViewBookingModal(props) {
  const { locations, booking, open, onClose } = props;
  const { type } = booking;
  const isBlock = type === BookingTypes.BLOCK;

  return (
    <Modal open={open} onClose={() => onClose(booking)}>
      <DialogContent className={modalStyles.modalContainer}>
        <ClickAwayListener onClickAway={() => onClose(booking)}>
          <div className={modalStyles.modalInner}>
            <Paper className={styles.removeModal}>
              {isBlock ? (
                <BlockDetails block={booking} />
              ) : (
                <DeliveryDetails delivery={booking} locations={locations} />
              )}
            </Paper>
          </div>
        </ClickAwayListener>
      </DialogContent>
    </Modal>
  );
}

ViewBookingModal.propTypes = {
  booking: PropTypes.shape({}).isRequired,
  locations: PropTypes.shape({}).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
